import { Component, OnInit, Injector, Input, HostBinding } from "@angular/core";
import { BaseComponent } from "../../base.component";

@Component({
  selector: "exsitng-account",
  template: `
    <h2 class="main-title">
      {{ control.attributes.title }}
    </h2>

    <div *ngIf="error" class="error-container">
      <div class="error">
        <i class="error-icon"></i>
        {{ error }}
      </div>
    </div>

    <div class="options top-margin">
      <div class="existing">
        <div
          class="subtitle-container"
          (click)="setAnswer(control.attributes.existingAccountValue)"
        >
          <!-- todt -activate table onclick -->
          <radio-button
            [selectedValue]="value"
            [value]="control.attributes.existingAccountValue"
            [control]="control"
            [context]="context"
            [setAnswer]="setAnswer"
            [disabled]="control.disabled"
            (emitParent)="
              ExsitingSetAnswer(control.attributes.existingAccountValue)
            "
          >
          </radio-button>

          <div class="subtitle">
            {{ control.attributes.selectAccountTitle }}
          </div>
        </div>

        <div class="users-container">
          <table
            class="users"
            [ngClass]="{
              disabled: value !== control.attributes.existingAccountValue
            }"
          >
            <thead class="users-header">
              <tr>
                <td>Customer Name</td>
                <td>Address</td>
                <td>Phone Number</td>
                <td>E-mail</td>
              </tr>
            </thead>

            <tbody class="users-body">
              <tr
                [tabindex]="isKeyBoardNavigationAllowed()"
                *ngFor="let user of control.attributes.options"
                (click)="setSelectedUser(user)"
                (keydown)="onKeyBoardSelectRow($event, user)"
                [ngClass]="{ selected: selectedUser === user }"
              >
                <td>{{ user.name }}</td>
                <td>{{ user.address }}</td>
                <td>{{ user.phone }}</td>
                <td>{{ user.email }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <h2 class="top-margin" *ngIf="control.attributes.newAccountTitle">
        Or
      </h2>

      <div
        class="new-user top-margin"
        *ngIf="control.attributes.newAccountTitle"
      >
        <div
          class="subtitle-container"
          (click)="setAnswer(control.attributes.newAccountValue)"
        >
          <radio-button
            [selectedValue]="value"
            [value]="control.attributes.newAccountValue"
            [setAnswer]="setAnswer"
            [context]="context"
            [control]="control"
            [disabled]="control.disabled"
            (emitParent)="ExsitingSetAnswer(control.attributes.newAccountValue)"
          >
          </radio-button>

          <div class="subtitle">
            {{ control.attributes.newAccountTitle }}
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ["./existing-account.component.scss"]
})
export class ExistingAccountAccountComponent extends BaseComponent
  implements OnInit {
  selectedUser: any;
  @HostBinding("attr.name")
  name = this.control ? this.control.name : "";
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    var t = this.control;
  }

  setSelectedUser(user) {
    this.selectedUser = user;
    const key = this.selectedUser.optionName;
    const value = this.selectedUser.id;
    const ajaxInfo = this.control.ajaxInfo;

    return this.storeService.updateData(key, value, "modal");
  }

  ExsitingSetAnswer(value) {
    this.setAnswer(value);
    this.value = value;
  }

  onKeyBoardSelectRow(event, user) {
    // if "Enter" or "Space" pressed
    if (event.keyCode === 13 || event.keyCode === 32) {
      this.setSelectedUser(user);
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
  }

  isKeyBoardNavigationAllowed() {
    if (
      this.elementRef.nativeElement
        .querySelectorAll("table")[0]
        .classList.contains("disabled")
    )
      return -1;
    return 0;
  }
}
